// Classes Block View Component (Read-only)
import React from 'react';
import { BookOpen } from 'lucide-react';

const ClassesBlockView = ({ content }) => {
  const { categoryFilter, showUpcoming, limit } = content || {};

  return (
    <div className="text-center py-8">
      <BookOpen className="w-16 h-16 text-[#7A99D8] mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-[#3C3C3C] dark:text-gray-100 mb-2">
        Classes
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        Class listings will be displayed here
      </p>
    </div>
  );
};

export default ClassesBlockView;
